import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";
import { ContactButton } from "../components/Project/Contact";
import { List as PointList } from "../components/Project/Choose";
import { VoiceList, Pagination } from "../components/Post";
import { useParams } from "react-router-dom";

const Voice = () => {
  const gridProps = {
    list: {
      gap: ['64px', '24px'],
      layout: ['repeat(3, 1fr)', '100%'],
      size: '100%',
    }
  }
  
  const parms = useParams();
  
  const args = {
    page: parms.id ? parms.id : 1,
    type: 'works',
    perPage: 12
  }

  return (
    <>
      <Head slug="voice" type="center"></Head>
        <div className="l-row">
          
          <Space size={['0 0 120px', '0 0 80px']}>
            
            <Grid {...gridProps.list}>
              <VoiceList perPage={args.perPage} page={args.page}></VoiceList>
            </Grid>
    
            <Pagination page={args.page} postType={args.type} perPage={args.perPage}></Pagination>

          </Space>

        </div>
      <Banner></Banner>
      <Contact></Contact>
    </>
  );
};

export default Voice;